<template>
  <div class="container BlogRoot" v-if="WebinarItems">
    <main role="main" class="pb-3">
      <b-tabs :value="tabIndex">
        <b-tab
          class="card card-default border-0"
          @click="
            (ind) => {
              $emit('loadCategory', { cat: Cat, page: 1 });
            }
          "
          :title="Cat.title"
          v-for="Cat in UpcomingCategories"
          :key="Cat.id"
          :active="Cat == UpcomingCategories[tabIndex]"
        >
          <div class="card-body vertical-align px-0 pt-3 pb-0">
            <div class="col-md-10">
              <h1>{{ Cat.title }}</h1>
              <p>
                <LinkToTradespoon
                  :text="Cat.description"
                  :promotion_id="Cat.tradespoonId"
                />
              </p>
            </div>
            <div class="col-12 col-md-2 col-sm-2 pb-3 pb-md-0">
              <img
                class="img-fluid rounded-2 center-block"
                :src="'/images/' + Cat.imageUrl"
                alt="Trading Guide"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <div
        class="card card-default border-top-0 border-right-0 border-left-0 mb-3"
        v-for="webinar in WebinarItems"
        :key="webinar.id"
      >
        <UpcomingWebinar :webinar="webinar" />
      </div>
      <b-pagination
        :value="currentPage"
        @change="
          (ind) => {
            $emit('loadCategory', {
              cat: Categories[this.tabIndex],
              page: ind,
            });
          }
        "
        :totalRows="totalPages"
        :per-page="perPage"
      />
    </main>
  </div>
</template>

<script>
import UpcomingWebinar from "./UpcomingWebinar.vue";
import LinkToTradespoon from "./LinkToTradespoon.vue";
export default {
  name: "UpcomingWebinarsPage",
  components: {
    UpcomingWebinar,
    LinkToTradespoon,
  },
  props: {
    WebinarItems: Array,
    Categories: Array,
    currentPage: Number,
    totalPages: Number,
    tabIndex: Number,
  },
  computed: {
    UpcomingCategories() {
      return this.Categories.filter((e) => e.announceable == true);
    },
  },
  data() {
    return { perPage: 4 };
  },
};
</script>

<style>
</style>
